import { API_KEYS, BASE_URL } from './constants.js';

export const DOMAIN_API_KEY = ((document, window) => {
  if (!('raiSsoDomainApiKey' in window) || !window.raiSsoDomainApiKey) {
    const ssoApiKeyEl = document.getElementById('ssoDomainApiKey');
    let apiKey: string;
    if (!ssoApiKeyEl?.innerText) {
      apiKey = API_KEYS.raiplay;
      const hostname = document.location.hostname;
      if (/^(?:www\.)?raiplaysound/.test(hostname)) {
        apiKey = API_KEYS.sound;
      } else if (/(?:rairadio|radiorai|raiplayradio)\.it/.test(hostname)) {
        apiKey = API_KEYS.radio;
      } else if (hostname === 'www.rai.it') {
        apiKey = API_KEYS.rai;
      } else if(hostname === 'www.raiplayyoyo.it') {
        apiKey = API_KEYS.yoyo;
      } else if (/raiplay-(?:demo|dev|int)\.rai\.it/.test(hostname)) {
        apiKey = API_KEYS.raiplay2020;
      }
    } else {
      apiKey = ssoApiKeyEl.innerText;
    }
    window.raiSsoDomainApiKey = apiKey;
  }
  return window.raiSsoDomainApiKey;
})(document, window);

export const RAI_SSO_SERVICE_URL = ((hostname) => {
  let url = BASE_URL.default;
  if (['10.99.40.16', '127.0.0.1'].includes(hostname)) {
    url = BASE_URL.default;
  } else if (/^sstest\.rai/.exec(hostname)) {
    url = BASE_URL.test;
  }
  return `${url}atomatic/raisso-service`;
})(document.location.hostname);
